import React, { forwardRef, useContext } from 'react';
import styled from 'styled-components';
import { CardStyle } from './Card.styles.js';
import { CardContext } from './CardContext.js';
import { useCardState } from './hooks.js';

const defaultProps = {
    variant: 'outlined',
    rounding: 'sharp',
    tagName: 'article',
};
// Interactive elements that when clicked on,
// do not trigger Card's own onClick handler.
// This is only when block link feature is enabled.
const ignoredOnClickElements = [
    'A',
    'BUTTON',
    'DATALIST',
    'OPTION',
    'SELECT',
    'TEXTAREA',
    'INPUT',
];
const _Card = forwardRef((props, ref) => {
    const { children, hasLink, linkFocusState, onClick, rounding, // Used only in styling, prevent passing it to DOM,
    tagName, theme, // Used only in styling, prevent passing it to DOM,
    variant, // Used only in styling, prevent passing it to DOM,
    ...rest } = props;
    const context = useContext(CardContext);
    const Tag = tagName !== null && tagName !== void 0 ? tagName : defaultProps.tagName;
    const blockLinkEventHandling = () => {
        var _a, _b, _c;
        const isTextSelected = (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString();
        if (!isTextSelected) {
            (_c = (_b = context === null || context === void 0 ? void 0 : context.linkRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.click();
        }
    };
    const cardOnClickHandler = event => {
        const eventTargetNode = event.target.nodeName;
        if (!ignoredOnClickElements.includes(eventTargetNode)) {
            if (context === null || context === void 0 ? void 0 : context.hasLink)
                blockLinkEventHandling();
            if (onClick)
                onClick(event);
        }
    };
    return (React.createElement(Tag, { ref: ref, onClick: cardOnClickHandler, ...rest }, children));
});
_Card.displayName = '_Card';
const StyledCustomTag = styled(_Card).attrs((props) => {
    const context = useContext(CardContext);
    return {
        ...props,
        hasLink: context === null || context === void 0 ? void 0 : context.hasLink,
        linkFocusState: context === null || context === void 0 ? void 0 : context.linkFocusState,
    };
}) `
    ${CardStyle}
`;
const CardProvider = forwardRef((props, ref) => {
    const [state, dispatch] = useCardState();
    const providerValue = {
        ...state,
        dispatch,
    };
    return (React.createElement(CardContext.Provider, { value: providerValue },
        React.createElement(StyledCustomTag, { ref: ref, ...props })));
});
CardProvider.displayName = 'CardProvider';
const Card = styled(CardProvider) ``;
Card.defaultProps = defaultProps;

export { Card, _Card, defaultProps };
//# sourceMappingURL=Card.js.map
